import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "py-2 -mx-2"
};
import LeagueDivisionComponent from "@/modules/competitions/components/divisions/LeagueDivision.vue";
import { LeagueDivision } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import Submenu from "./Submenu";
import ActionButton from "./ActionButton.vue";
import { onBeforeRouteLeave } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'Table',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const division = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      division.value = await LeagueDivision.createQueryBuilder('division').innerJoinAndSelect('division.competition', 'competition').leftJoin('division.relegated', 'relegatedTeam').leftJoin('division.promoted', 'promotedTeam').innerJoinAndSelect('competition.country', 'country').innerJoinAndSelect('competition.divisions', 'competitionDivision').innerJoinAndSelect('division.promotions', 'promotion').innerJoinAndSelect('division.stats', 'stats').innerJoinAndSelect('stats.division', 'division2').innerJoinAndSelect('stats.team', 'team').innerJoin('stats.season', 'season').where('season.current = true').andWhere('division.id = :id', {
        id: route.params.id
      }).getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [division.value.competition.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: division.value.competition.country,
          class: "mr-2"
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(division.value.name), 1)])]),
        submenu: _withCtx(() => [_createVNode(_unref(Submenu), {
          "has-table": ""
        })]),
        actionButton: _withCtx(() => [_createVNode(ActionButton, {
          division: division.value,
          divisions: division.value.competition.divisions
        }, null, 8, ["division", "divisions"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(LeagueDivisionComponent, {
          division: division.value
        }, null, 8, ["division"])])]),
        _: 1
      });
    };
  }
});